'use client';

import MessageAgentForm from '~/components/Agents/MessageAgent/MessageAgentForm';
import MessageAgentModal from '~/components/Agents/MessageAgent/MessageAgentModal';
import { useEffect, useState } from 'react';
import {
  postEvent,
  resetSession,
} from '~/components/Agents/MessageAgent/Analytics';
import { trackVirtualPageView } from '~/utils/Fetch/Analytics';
import { useUniversalRouter } from '~/utils/useUniversalRouter';

import Cta from '@referralexchange/rea-ui-react/src/components/blocks/Cta';
import Button from '@referralexchange/rea-ui-react/src/atoms/Button';

export default function MessageAgentCta(props) {
  const { funnel, fullInteractive } = props;
  const INITIAL_STEP = 1;
  const router = useUniversalRouter();
  const [confirmClose, setConfirmClose] = useState(false);
  const [step, setStep] = useState(INITIAL_STEP);
  const [largeModal, setLargeModal] = useState(false);
  const [modalOpen, setModalOpen] = useState(false);

  useEffect(() => {
    if (modalOpen) {
      setStep(INITIAL_STEP);
    }
  }, [modalOpen]);

  const onRequestClose = (e, confirm = false) => {
    if (step === INITIAL_STEP) {
      setConfirmClose(false);
      postEvent('message_agent_modal_closed', router, null, funnel);
      resetSession();
      setModalOpen(false);
    } else if (confirm) {
      setConfirmClose(true);
      postEvent('message_agent_modal_exit_attempt', router, null, funnel);
    } else if (confirm === null) {
      setConfirmClose(false);
    } else {
      setModalOpen(false);
      postEvent('message_agent_modal_closed', router, null, funnel);
      resetSession();
      setTimeout(() => {
        setConfirmClose(false);
      }, 200);
    }
  };

  const openModal = () => {
    setModalOpen(true);
    trackVirtualPageView('funnel_start', funnel);
  };

  return (
    <>
      <div
        style={fullInteractive ? { cursor: 'pointer' } : null}
        onClick={fullInteractive ? openModal : null}
      >
        <Cta heading={'Find Your Perfect Agent'} gradient {...props}>
          <Button onClick={!fullInteractive ? openModal : null}>
            Get Started
          </Button>
        </Cta>
      </div>
      <MessageAgentModal
        confirmClose={confirmClose}
        isOpen={modalOpen}
        largeModal={largeModal}
        onRequestClose={onRequestClose}
        agent={{}}
        funnel={funnel}
      >
        <MessageAgentForm
          agent={{ prime: true }}
          funnel={funnel}
          isClaimed={true}
          isOpen={modalOpen}
          afterNewScreen={setStep}
          step={step}
          onRequestClose={onRequestClose}
          onRequestLargeModal={setLargeModal}
        />
      </MessageAgentModal>
    </>
  );
}
